export const buttonBoxStylesCP = {
    wrapper: {
        margin: "12px 2% 30px 2%",
        display: "grid",
        gridTemplateColumns: "auto auto auto",
        gap: "8px",
        justifyContent: "center"
    },
    button: {
        height: "40px",
        border: "1px solid #d6d6d6",
        borderRadius: "20px",
        width: "auto !important",        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#474747"
    },
    buttonDisabled: {
        height: "40px",
        border: "1px solid #f5f5f5",
        borderRadius: "20px",
        width: "115px",        
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#ffffff",
        color: "#848484"
    },
    buttonIcon: {
        marginRight: "8px",
        height: "22px",
        width: "22px"
    },
    buttonText: {
        fontSize: "12px",
        fontFamily: "Roboto",
    }
}

export const buttonBoxStylesContainerTelcel = {
    wrapper: {
        display: "none"
    }
}